import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useCertero } from "@/context/CerteroContext";
import { EASE } from "@/components/Reveal";
import LeadForm from "@/components/LeadForm";

const TITLES = {
  cotizacion: ["Cotizar", "Cuéntenos qué equipo necesita y le responderemos con una propuesta formal."],
  soporte: ["Pedir soporte", "Su solicitud llega directo al departamento técnico, no a ventas. Puede adjuntar un enlace a fotos o video del problema."],
  emergencia: ["Emergencia en campo", "Atención urgente para su equipo en campo. Cuanto antes escriba, antes lo alcanzamos."],
  academia: ["CERTERO Academy", "Únase a la lista de interesados y le informaremos de fechas y modalidades."],
  servicio: ["Solicitar servicio", "Indique su zona y cultivo para coordinar la operación."],
  campana: ["Agendar campaña", "Cuéntenos qué cultivo, cuántas hectáreas y en qué zona, y agendamos la campaña."],
  demo: ["Reservar demo", "Coordinemos una demostración en su zona."],
  repuesto: ["Consultar repuesto", "Díganos el modelo de su dron y la pieza que necesita: le confirmamos disponibilidad."],
  contacto: ["Contacto", "Escríbanos y le responderemos a la brevedad."],
};

export default function LeadModal() {
  const { lead, closeLead } = useCertero();
  const [main, sub] = TITLES[lead.tipo] || TITLES.cotizacion;

  return (
    <AnimatePresence>
      {lead.open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[80] flex items-end justify-center bg-ink/80 backdrop-blur-sm sm:items-center sm:p-6"
          onClick={closeLead}
          data-testid="lead-modal-overlay"
        >
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 40 }}
            transition={{ duration: 0.45, ease: EASE }}
            onClick={(e) => e.stopPropagation()}
            className="max-h-[92vh] w-full max-w-xl overflow-y-auto border border-hud bg-surface"
            data-testid="lead-modal"
            role="dialog"
            aria-modal="true"
            aria-label={main}
          >
            <div className="sticky top-0 z-10 flex items-start justify-between gap-4 border-b border-hud bg-surface/95 p-6 backdrop-blur-sm sm:p-8">
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-certero">CERTERO SRL</p>
                <h2 className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-mist sm:text-2xl">
                  {main}
                </h2>
                {sub && <p className="mt-2 max-w-md text-sm leading-relaxed text-smoke">{sub}</p>}
              </div>
              <button
                data-testid="lead-modal-close"
                onClick={closeLead}
                aria-label="Cerrar"
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-hud text-mist/70 transition-colors duration-300 hover:border-certero hover:text-certero"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <div className="p-6 sm:p-8">
              {lead.interes && (
                <p className="mb-5 inline-block border border-certero/50 bg-certero/10 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-certero">
                  Interés: {lead.interes}
                </p>
              )}
              <LeadForm tipo={lead.tipo} interes={lead.interes} buttonLabel="Enviar solicitud" />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
